import type {PanelBooking} from "../types.ts";

export function nextFocusKey(
    bookings: PanelBooking[],
    focusedKey: string | null,
    offset: number,
): string | null {
    if (bookings.length === 0) return null;

    const currentIndex = bookings.findIndex((booking) => booking.key === focusedKey);
    if (currentIndex === -1) return bookings[offset > 0 ? 0 : bookings.length - 1].key;

    const nextIndex = Math.min(Math.max(currentIndex + offset, 0), bookings.length - 1);
    return bookings[nextIndex].key;
}

export function rowTabIndex(
    bookings: PanelBooking[],
    focusedKey: string | null,
    key: string,
): 0 | -1 {
    if (focusedKey !== null) return focusedKey === key ? 0 : -1;
    return bookings.length > 0 && bookings[0].key === key ? 0 : -1;
}
